import { Component } from '@angular/core';

@Component({
  selector: 'mnc-wcc-samples',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class SamplesComponent {
}
